import React, {useState} from 'react'
import Box from '../../ui/box/Box'
import Title from '../../ui/page/Title'
import MagasinMenu from '../magasin/MagasinMenu'
import {PointagesContent} from './PointagesContent.tsx'

const Pointages = () => {
    const [currentTab, setCurrentTab] = useState('pointages');

    return (
        <>
            <Title title={'Mon magasin'} />
            <Box
                boxName={'magasin'}
                boxClassNames={'flex-column'}
                header={true}
                headerClassNames={'rounded-top'}
                boxContentBg={'white'}
                headerContent={
                    <>
                        <MagasinMenu
                            currentTab={currentTab}
                            setCurrentTab={setCurrentTab}
                        />
                    </>
                }
                content={<PointagesContent />}
            />
        </>
    )
}

export default Pointages
